import React from 'react';
import { motion } from 'framer-motion';
import Logo from '../Common/Logo';

const LoadingOverlay = () => {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center overflow-hidden"
      style={{
        // Using inline styles ensures this works regardless of Tailwind version/config
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)', // Essential for Safari support
      }}
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{
          duration: 0.5,
          ease: 'easeOut',
        }}
        className="flex flex-col items-center"
      >
        <motion.div
          animate={{
            scale: [1, 1.2, 1],
          }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
          className="relative w-28 h-28"
        >
          <img
            src="/agency/assets/workfall-logo.svg"
            alt="workfall logo"
            className="w-full h-[50px] object-contain"
          />
          {/* <Logo /> */}
        </motion.div>
      </motion.div>
    </div>
  );
};

export default LoadingOverlay;
